// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610131505/js/" + chunkId + "." + {"44":"703caa26","225":"7baef292","481":"1348b93c","486":"57343b65","770":"b6678d8e"}[chunkId] + ".0.4284767336833796.chunk.js";
};